module.exports = __webpack_public_path__ + "img/procon_snap.3ec12f4e.png";